module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/download-9b0b7083225da1a5d781a5a186a2990c.svg";